export default __webpack_public_path__ + "static/media/874.46757e84.png";